module.exports = __webpack_public_path__ + "img/T4-B-rc_18.ec360dde.png";